<template>
  <div style="width:100%;">
    <el-checkbox-group v-model="ids">
      <el-checkbox
        v-for="item in list"
        :key="item.serviceId"
        :label="item.serviceId">{{ item.serviceName }}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'ProductGroupSelect',
  components: { },
  props: {
    value: {
      required: true
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    ids: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.$store.dispatch('account/getservices', {
        payload: this.config,
        success: (res) => {
          this.list = res.data.records
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
